export enum LogLevel {
    DEBUG,
    INFO,
    WARN,
    ERROR
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/domain/enums/log-level.enum.ts